import styled from 'styled-components';
import { COLOR } from '@styles/theme';

export const EXPAND_COLUMN_WIDTH = 128;

const rowActionsHidden = `
  .inventory-row-actions {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  .inventory-row-actions-trigger.ant-dropdown-open .inventory-row-actions {
    opacity: 1;
  }
`;

export const InventoryTableWrapper = styled.div`
  /* Product rows only — exclude expanded row (it wraps the whole lot sub-table). */
  .inventory-list-table .ant-table-tbody > tr:not(.ant-table-expanded-row):hover
    > td
    .inventory-row-actions {
    opacity: 1;
  }

  .inventory-list-table {
    ${rowActionsHidden}

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      vertical-align: middle;
    }
  }

  .inventory-list-expanded-row > .ant-table-cell {
    background: #fafafa;
    padding: 0 !important;
  }

  .inventory-list-lot-table {
    ${rowActionsHidden}

    .ant-table-tbody > tr:hover > td .inventory-row-actions {
      opacity: 1;
    }

    .ant-table {
      margin: 0 !important;
      background: transparent;
    }

    .ant-table-tbody > tr > td {
      vertical-align: middle;
      border-bottom: 1px solid ${COLOR.border};
    }

    .ant-table-tbody > tr:last-child > td {
      border-bottom: none;
    }
  }
`;

export const RowActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  min-height: 32px;
  margin-left: auto;
`;

/** @deprecated Use RowActionsCell */
export const LotsColumnCell = RowActionsCell;

export const LotsExpandToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;
  color: #393948;
  text-align: left;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.grey};
  }
`;

/** Fixed product thumbnail so list rows stay aligned regardless of source image dimensions. */
export const ProductThumb = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 5px;

  img.ui.image,
  .ui.image img,
  .ui.image {
    width: 48px !important;
    height: 48px !important;
    max-width: 48px !important;
    max-height: 48px !important;
    object-fit: contain;
    margin: 0 !important;
  }
`;
